export default __webpack_public_path__ + "static/media/06AW1SEP66.e063d243.jpg";